module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container",
    attrs: {
      "id": "mobileViewPort"
    }
  }, [_c('div', {
    attrs: {
      "id": "mobileMode"
    }
  }, [_c('div', {
    attrs: {
      "id": "titleArea"
    }
  }, [_c('div', {
    staticClass: "titleText"
  }, [_vm._v("在校证明")]), _vm._v(" "), _c('div', {
    staticClass: "titleButton"
  }, [_c('el-button', {
    staticClass: "custom-el-button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showHomePage
    }
  }, [_c('i', {
    staticClass: "el-icon-s-home"
  }), _vm._v(" 首页\n                ")])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "queryArea"
    }
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('div', {
    staticClass: "formItem"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "审核状态(全部)",
      "clearable": ""
    },
    on: {
      "change": _vm.handleFilter
    },
    model: {
      value: (_vm.queryForm.auditState),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "auditState", $$v)
      },
      expression: "queryForm.auditState"
    }
  }, _vm._l((_vm.comboData.auditState), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "formItem text-center"
  }, [_c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.createCertificate
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus-outline"
  }), _vm._v("\n                        申请\n                    ")])], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "listArea"
    },
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(_vm.tableData == null || _vm.tableData.length == 0) ? _c('div', {
    staticClass: "cardTips"
  }, [_vm._v("没有申请记录")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cardMain"
    }, [_c('div', {
      staticClass: "cardText"
    }, [_c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("学       号：")]), _vm._v(_vm._s(item.stuCode))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("姓       名：")]), _vm._v(_vm._s(item.stuName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("创建时间：")]), _vm._v(_vm._s(item.cjsj))]), _vm._v(" "), _c('div', {
      staticClass: "auditStateImg"
    }, [_c('img', {
      attrs: {
        "src": _vm.loadStateImg(item),
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "cardInput"
    }, [(item.auditState == '1') ? _c('el-button', {
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.openDialog(item)
        }
      }
    }, [_vm._v("在校证明")]) : _vm._e(), _vm._v(" "), (item.submitState == '0') ? _c('el-button', {
      attrs: {
        "type": "warning"
      },
      on: {
        "click": function($event) {
          return _vm.outsideSub(item)
        }
      }
    }, [_vm._v("提交\n                    ")]) : _vm._e(), _vm._v(" "), (item.submitState == '1') ? _c('el-button', {
      attrs: {
        "type": "info"
      },
      on: {
        "click": function($event) {
          return _vm.showCertificateInfo('view', item)
        }
      }
    }, [_vm._v("详情\n                    ")]) : _vm._e(), _vm._v(" "), (item.submitState == '1' || item.auditState == '1' || item.auditState == '2') ? _c('el-button', {
      on: {
        "click": function($event) {
          return _vm.showAuditList(item)
        }
      }
    }, [_vm._v("审核信息\n                    ")]) : _vm._e()], 1)])
  }), _vm._v(" "), (_vm.total > 2 && _vm.total > _vm.tableData.length) ? _c('div', {
    attrs: {
      "id": "loadingTips"
    }
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" 信息加载中，请稍后...\n            ")]) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": "在校证明申请",
      "visible": _vm.applyDialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.applyDialogVisible = $event
      }
    }
  }, [_c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "mainDialogScroll"
    }
  }, [_c('el-form', {
    ref: "applyForm",
    attrs: {
      "model": _vm.applyForm,
      "label-width": "84px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.applyForm.stuName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学号"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.applyForm.stuCode) + "\n                    ")]), _vm._v(" "), (_vm.flag.viewFlag == true) ? _c('div', [_vm._v(_vm._s(_vm.applyForm.jssj))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.flag.setFlag) ? _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("提交\n                ")]) : _vm._e(), _vm._v(" "), (_vm.flag.setFlag) ? _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.applyDialogVisible = false
      }
    }
  }, [_vm._v("取 消\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.flag.setFlag) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.applyDialogVisible = false
      }
    }
  }, [_vm._v("关 闭\n                ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.closeDialog
    }
  }, [_c('el-scrollbar', {
    ref: "printDialogScroll",
    attrs: {
      "id": "printDialogScroll"
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', [_c('div', {
    staticStyle: {
      "height": "680px"
    }
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "fileInfo": _vm.fileInfo,
      "height": 650
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.fileDownload()
      }
    }
  }, [_vm._v("导 出\n                ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("关 闭\n                ")])], 1)], 1), _vm._v(" "), (_vm.auditListDialogVisible) ? _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "title": "审核信息",
      "visible": _vm.auditListDialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.auditListDialogVisible = $event
      }
    }
  }, [_c('div', [_c('auditList', {
    ref: "auditList",
    attrs: {
      "relatedCode": _vm.certificateInfo.id,
      "listHeight": 450
    }
  })], 1)]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46930d3b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/atSchoolCertificateStuMobile.vue
// module id = 1819
// module chunks = 502